// projects/humanresources-personnel/src/assets/i18n/*/hr-per-punishment.json
export class HrPerPunishmentKey {
    private static readonly keyPrefix = 'hrPerPunishment';
    public static title = `${HrPerPunishmentKey.keyPrefix}.title`;
    public static investigationTitle = `${HrPerPunishmentKey.keyPrefix}.investigationTitle`;
    public static investigation = `${HrPerPunishmentKey.keyPrefix}.investigation`;
    public static hrmTypeUuid = `${HrPerPunishmentKey.keyPrefix}.hrmTypeUuid`;
    public static enumPunishmentStatus = `${HrPerPunishmentKey.keyPrefix}.enumPunishmentStatus`;
    public static objection = `${HrPerPunishmentKey.keyPrefix}.objection`;
    public static typeId = `${HrPerPunishmentKey.keyPrefix}.typeId`;
    public static subtypeId = `${HrPerPunishmentKey.keyPrefix}.subtypeId`;
    public static decision = `${HrPerPunishmentKey.keyPrefix}.decision`;
    public static cancellationDate = `${HrPerPunishmentKey.keyPrefix}.cancellationDate`;
    public static reason = `${HrPerPunishmentKey.keyPrefix}.reason`;
    public static lawNumber = `${HrPerPunishmentKey.keyPrefix}.lawNumber`;
    public static finalizedDate = `${HrPerPunishmentKey.keyPrefix}.finalizedDate`;
    public static lawsuitCancellationDate = `${HrPerPunishmentKey.keyPrefix}.lawsuitCancellationDate`;
}
